webpackJsonp([35783957827783],{

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bnr1.e30bac92.jpg";

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bnr2.a7fead93.jpg";

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ted.3671f986.jpg";

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _board = __webpack_require__(35);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(343);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _bnr = __webpack_require__(614);
	
	var _bnr2 = _interopRequireDefault(_bnr);
	
	var _bnr3 = __webpack_require__(615);
	
	var _bnr4 = _interopRequireDefault(_bnr3);
	
	var _ted = __webpack_require__(156);
	
	var _ted2 = _interopRequireDefault(_ted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var disableForm = true;
	
	exports.default = function (_ref) {
		var data = _ref.data;
		return _react2.default.createElement(
			"div",
			null,
			_react2.default.createElement(_reactHelmet2.default, {
				title: data.site.siteMetadata.title
			}),
			_react2.default.createElement(
				"h1",
				{ className: _indexModule2.default.title },
				data.site.siteMetadata.title
			),
			_react2.default.createElement(
				"section",
				{ className: _indexModule2.default.banners },
				_react2.default.createElement(
					"a",
					{ href: "https://docs.google.com/forms/d/e/1FAIpQLSfEpv3de6uwkQ-n0BW7HWrSh-71b-ztWqefCGDRM4qXAaUpWw/viewform",
						target: "__blank" },
					_react2.default.createElement("img", { src: _bnr2.default, className: _indexModule2.default.banner })
				)
			),
			_react2.default.createElement(
				"section",
				null,
				_react2.default.createElement(
					_board2.default,
					null,
					_react2.default.createElement(
						"div",
						{ style: { marginBottom: "-10px" } },
						_react2.default.createElement(
							"div",
							{ style: { float: "left", marginLeft: "1rem" } },
							function () {
								if (disableForm) {
									return _react2.default.createElement(
										"div",
										{ style: { backgroundColor: "yellow", padding: "0.3rem 1rem", marginBottom: 0 } },
										_react2.default.createElement(
											"b",
											null,
											"\u7D42\u4E86"
										)
									);
								} else {
									return _react2.default.createElement(
										"p",
										{ style: { fontSize: "1rem", marginBottom: 0 } },
										"Next>>"
									);
								}
							}()
						),
						_react2.default.createElement(
							"div",
							{ style: { float: "right", marginRight: "1rem" } },
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/archives/\u8996\u8074\u4F1A/" },
								_react2.default.createElement(
									"p",
									{ className: _indexModule2.default.tags },
									"#\u8996\u8074\u4F1A"
								)
							)
						)
					),
					_react2.default.createElement("br", { style: { clear: "both" } }),
					_react2.default.createElement(
						"div",
						{ className: _indexModule2.default.nextInfo },
						_react2.default.createElement(
							"h3",
							{ className: _indexModule2.default.topic },
							"Vol.2\u3000TED Talks \u8996\u8074\u4F1A"
						),
						_react2.default.createElement("img", { src: _ted2.default }),
						_react2.default.createElement(
							"blockquote",
							null,
							"\u30D0\u30FC\u306E\u4E00\u89D2\u3067\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u3092\u4F7F\u3044TED Talks\u306E\u30A2\u30FC\u30AB\u30A4\u30D6\u3092\u8996\u8074\u3057\u307E\u3059\u3002",
							_react2.default.createElement("br", null),
							"\u53C2\u52A0\u8CBB\u306F\u7121\u6599\u3001\u3044\u3064\u6765\u3066\u3044\u3064\u5E30\u3063\u3066\u3082OK\u3067\u3059\u3002",
							_react2.default.createElement("br", null),
							"\u203B\u30D0\u30FC\u306E\u30C1\u30E3\u30FC\u30B8\u6599\u91D1(500\u5186)\uFF0B\u3054\u81EA\u8EAB\u306E\u30C9\u30EA\u30F3\u30AF\u4EE3\u304C\u304B\u304B\u308A\u307E\u3059\u3002"
						),
						_react2.default.createElement(
							"h4",
							null,
							"\u3044\u307E\u306E\u3068\u3053\u308D\u89B3\u305F\u3044\u3068\u601D\u3063\u3066\u3044\u308B\u3082\u306E"
						),
						_react2.default.createElement(
							"ul",
							null,
							_react2.default.createElement(
								"li",
								null,
								"\u30B5\u30E0\u30FB\u30CF\u30EA\u30B9\uFF1A \u9053\u5FB3\u89B3\u306B\u307E\u3064\u308F\u308B\u79D1\u5B66"
							),
							_react2.default.createElement(
								"li",
								null,
								"\u30B5\u30E0\u30FB\u30CF\u30EA\u30B9\uFF1A \u4EBA\u9593\u3088\u308A\u512A\u308C\u305F\u4EBA\u5DE5\u77E5\u80FD\u3092\u4F5C\u3063\u3066\u5236\u5FA1\u3092\u5931\u308F\u305A\u306B\u3044\u308B\u3053\u3068\u306F\u53EF\u80FD\u304B\uFF1F"
							),
							_react2.default.createElement(
								"li",
								null,
								"\u30DE\u30A4\u30B1\u30EB\u30B7\u30E3\u30FC\u30DE\u30FC: \u4E0D\u601D\u8B70\u306A\u3082\u306E\u3092\u4FE1\u3058\u308B"
							)
						),
						_react2.default.createElement(
							"p",
							null,
							"\u4ED6\u306B\u3082\u73FE\u5730\u3067\u610F\u898B\u3092\u805E\u3044\u3066\u7686\u306E\u8208\u5473\u306E\u3042\u308B\u3082\u306E\u3092\u518D\u751F\u3057\u305F\u3044\u3068\u601D\u3044\u307E\u3059\u3002"
						),
						_react2.default.createElement(
							"h4",
							{ className: _indexModule2.default.sectionTitle },
							"\u65E5\u6642"
						),
						_react2.default.createElement(
							"p",
							null,
							"2017/12/13 (\u6C34)\u300020:30 ~ \u5927\u4F530:00\u304F\u3089\u3044"
						),
						_react2.default.createElement(
							"h4",
							{ className: _indexModule2.default.sectionTitle },
							"\u4F1A\u5834"
						),
						_react2.default.createElement(
							"p",
							null,
							"UNDER BAR",
							_react2.default.createElement("br", null),
							"\u672D\u5E4C\u5E02\u4E2D\u592E\u533A\u53575\u6761\u897F2\u4E01\u76EE8-9\u793E\u4EA4\u4F1A\u9928 5\u968E",
							_react2.default.createElement("br", null),
							_react2.default.createElement(
								"a",
								{ href: "http://wavs.jp/?project=underbar", target: "__blank" },
								"http://wavs.jp/?project=underbar"
							)
						),
						_react2.default.createElement(
							"h4",
							{ className: _indexModule2.default.sectionTitle },
							"\u6599\u91D1"
						),
						_react2.default.createElement(
							"p",
							null,
							"\u30D0\u30FC\u306E\u30C1\u30E3\u30FC\u30B8\u6599\u91D1500\u5186\uFF0B\u3054\u81EA\u8EAB\u306E\u30C9\u30EA\u30F3\u30AF\u4EE3\uFF08500\u5186\uFF5E\uFF09"
						),
						_react2.default.createElement(
							"form",
							{ name: "reserve", "netlify-honeypot": "bot-field", action: "thank-you", "data-netlify": "true", style: { overflow: "hidden", display: "none" } },
							_react2.default.createElement(
								"h4",
								null,
								"\u7533\u8FBC\u307F"
							),
							_react2.default.createElement(
								"p",
								null,
								"\u53C2\u52A0\u306F\u4E8B\u524D\u4E88\u7D04\u5236\u3068\u306A\u308A\u307E\u3059\u3002",
								_react2.default.createElement("br", null),
								"\u4E0B\u8A18\u306E\u6CE8\u610F\u4E8B\u9805\u3092\u304A\u8AAD\u307F\u3044\u305F\u3060\u3044\u305F\u4E0A\u3067\u3001\u3053\u3061\u3089\u304B\u3089\u304A\u7533\u3057\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002",
								_react2.default.createElement("br", null),
								"\u306A\u304A\u5B9A\u54E110\u540D\u7A0B\u5EA6\u3092\u4E88\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002"
							),
							_react2.default.createElement(
								"p",
								{ style: { display: "none" } },
								_react2.default.createElement(
									"label",
									null,
									"Don\u2019t fill this out: ",
									_react2.default.createElement("input", { name: "bot-field" })
								)
							),
							_react2.default.createElement(
								"p",
								null,
								"\u203B\u7533\u3057\u8FBC\u307F\u53D7\u4ED8\u5B8C\u4E86\u5F8C\u306B\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u304A\u9001\u308A\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u30E1\u30FC\u30EB\u304C\u5C4A\u304B\u306A\u3044\u5834\u5408\u306F\u304A\u624B\u6570\u3067\u3059\u304C\u518D\u5EA6\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u306E\u4E0A\u9001\u4FE1\u3001\u307E\u305F\u306F",
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: "/contact" },
									"Contact"
								),
								"\u306E\u9023\u7D61\u5148\u307E\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									"label",
									null,
									"\u3000\u3000\u3000\u3054\u4E88\u7D04\u540D:\u3000",
									_react2.default.createElement("input", { type: "text", name: "name", className: _indexModule2.default.textField, disabled: disableForm })
								)
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									"label",
									null,
									"\u3000\u3000\u3000\u3000\u3000\u4EBA\u6570:\u3000",
									_react2.default.createElement(
										"select",
										{ size: "1", name: "count", className: _indexModule2.default.listBox, disabled: disableForm },
										_react2.default.createElement(
											"option",
											{ value: "1" },
											"1"
										),
										_react2.default.createElement(
											"option",
											{ value: "2" },
											"2"
										),
										_react2.default.createElement(
											"option",
											{ value: "3" },
											"3"
										),
										_react2.default.createElement(
											"option",
											{ value: "4" },
											"4"
										),
										_react2.default.createElement(
											"option",
											{ value: "5" },
											"5"
										),
										_react2.default.createElement(
											"option",
											{ value: "6" },
											"6"
										),
										_react2.default.createElement(
											"option",
											{ value: "7" },
											"7"
										),
										_react2.default.createElement(
											"option",
											{ value: "8" },
											"8"
										),
										_react2.default.createElement(
											"option",
											{ value: "9" },
											"9"
										)
									)
								)
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									"label",
									null,
									"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9:\u3000",
									_react2.default.createElement("input", { type: "text", name: "mail", className: _indexModule2.default.textField, disabled: disableForm })
								)
							),
							_react2.default.createElement(
								"label",
								null,
								"\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000",
								_react2.default.createElement("input", { type: "checkbox", name: "receiveNotification", disabled: disableForm }),
								"\u3000\u4ECA\u5F8C\u306E\u958B\u50AC\u60C5\u5831\u3092\u30E1\u30FC\u30EB\u3067\u53D7\u3051\u53D6\u308B"
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									"button",
									{ type: "submit" },
									"\u9001\u4FE1"
								)
							)
						),
						_react2.default.createElement(
							"aside",
							{ style: { display: "none" } },
							_react2.default.createElement(
								"h4",
								null,
								"\u6CE8\u610F\u4E8B\u9805"
							),
							_react2.default.createElement(
								"ul",
								null,
								_react2.default.createElement(
									"li",
									null,
									"\u5F53\u65E5\u4F1A\u5834\u5185\u306F\u7981\u7159\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u3054\u5354\u529B\u306E\u307B\u3069\u3088\u308D\u3057\u304F\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002"
								),
								_react2.default.createElement(
									"li",
									null,
									"\u5F53\u65E5\u30A4\u30D9\u30F3\u30C8\u306E\u6A21\u69D8\u306F\u52D5\u753B\u3067\u64AE\u5F71\u3057\u3001\u5F8C\u65E5\u914D\u4FE1\u3055\u305B\u3066\u3044\u305F\u3060\u304F\u4E88\u5B9A\u3067\u3059\u3002\u4E0D\u90FD\u5408\u306E\u3042\u308B\u65B9\u304C\u3044\u3089\u3063\u3057\u3083\u3044\u307E\u3057\u305F\u3089\u304A\u58F0\u304B\u3051\u304F\u3060\u3055\u3044\u3002"
								)
							)
						)
					)
				)
			)
		);
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"src-styles----index-module---title---2apK8","banners":"src-styles----index-module---banners---2-u21","banner":"src-styles----index-module---banner---LraMy","nextInfo":"src-styles----index-module---nextInfo---2tfbO","tags":"src-styles----index-module---tags---3kDpr","topic":"src-styles----index-module---topic---1Usv1","sectionTitle":"src-styles----index-module---sectionTitle---28xGe","textField":"src-styles----index-module---textField---3-uKt","listBox":"src-styles----index-module---listBox---3KCSg"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-76257df038fd41118ab7.js